import { alpha, color } from "metabase/lib/colors";
import styled from "@emotion/styled";
export const CalendarDay = styled.div`
  background-color: ${({
  primaryColor = color("brand"),
  isSelected,
  isInRange
}) => {
  if (isSelected) {
    return primaryColor;
  } else if (isInRange) {
    return alpha(primaryColor, 0.1);
  }
  return "transparent";
}};
  color: ${({ primaryColor = color("brand"), isSelected, isInRange }) => !isSelected && isInRange ? primaryColor : void 0};

  &:hover {
    background-color: ${({ primaryColor = color("brand") }) => primaryColor};
    color: white;
  }
`;
